// i18n-Helper fuer Frontend. Spiegelt die Backend-Logik aus
// server/models/TreatmentNoteTemplate.js (pickLocale).

import { I18nString, SupportedLocale } from '../services/apiService';

export const SUPPORTED_LOCALES: SupportedLocale[] = ['de', 'es', 'en'];

export function pickLocale(
    i18nObj: I18nString | undefined | null,
    locale: SupportedLocale | string | undefined,
    fallback: SupportedLocale = 'de',
): string {
    if (!i18nObj || typeof i18nObj !== 'object') return '';
    const l = (locale || '') as SupportedLocale;
    if (typeof i18nObj[l] === 'string' && i18nObj[l]!.length > 0) return i18nObj[l]!;
    if (typeof i18nObj[fallback] === 'string' && i18nObj[fallback]!.length > 0) return i18nObj[fallback]!;
    for (const lc of SUPPORTED_LOCALES) {
        if (typeof i18nObj[lc] === 'string' && i18nObj[lc]!.length > 0) return i18nObj[lc]!;
    }
    return '';
}

export function localeFromPatient(preferred?: string | null): SupportedLocale {
    if (preferred === 'es' || preferred === 'en' || preferred === 'de') return preferred;
    return 'de';
}
